import { configureStore } from "@reduxjs/toolkit";

import systemReducer from './system'
import searchReducer from './search'
import detailsReducer from './details'
import filesReducer from './files'
import procofilesReducer from './procofiles'
// import patientReducer from './patient'
import notificationReducer from './notifications'
import userReducer from './user'
import attorneyReducer from './attorneys'
import caseReducer from './case'
import insuranceReducer from './insurance'
import notesReducer from './notes'
import alertsReducer from './alerts'
import servicesReducer from './services'

import relatedPatientReducer from './relatedPatient'
import filterReducer from './filter'
import workqueueReducer from './workqueue'
import referralsReducer from './referrals'
import surgicalReducer from './surgical'
import historyReducer from './history'
import tasksReducer from './tasks'
import exportsReducer from './exports'
import transfersReducer from './transfers'
import appointmentsReducer from './appointments'
import permissionsReducer from './permissions'
import documentsReducer from './documents'
// import requestsReducer from './requests'
import tabsReducer from './tabs'
    
const store = configureStore({
    reducer: {
        system: systemReducer,
        search: searchReducer,
        details: detailsReducer,
        files: filesReducer,
        // patient: patientReducer,
        notification: notificationReducer,
        user: userReducer,
        attorney: attorneyReducer,
        case: caseReducer,
        insurance: insuranceReducer,
        notes: notesReducer,
        alerts: alertsReducer,
        services: servicesReducer,
        relatedPatient: relatedPatientReducer,
        filter: filterReducer,
        workqueue: workqueueReducer,
        surgical: surgicalReducer,
        procofiles: procofilesReducer,
        referrals: referralsReducer,
        history: historyReducer,
        tasks: tasksReducer,
        permissions: permissionsReducer,
        exports: exportsReducer,
        transfers: transfersReducer,
        appointments: appointmentsReducer,
        documents: documentsReducer,
        // requests: requestsReducer,
        tabs: tabsReducer,
    }
})

export default store